/** Formatadores locais de Relatórios > Vida útil do lead. */
import type { CacBasis } from '@/types/lead-lifetime';

const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const BRL4 = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 4 });
const NUM = new Intl.NumberFormat('pt-BR');

export const fmtLL = {
    brl: (v: number | null | undefined) => (v == null ? '—' : BRL.format(v)),
    /** Valores por lead costumam ter centavos quebrados (R$ 0,0873). */
    brlUnit: (v: number | null | undefined) => (v == null ? '—' : BRL4.format(v)),
    num: (v: number | null | undefined) => NUM.format(v || 0),
    /** ROI vem como fração (0,25 = 25%). */
    pct: (v: number | null | undefined) => (v == null ? '—' : `${(v * 100).toFixed(1).replace('.', ',')}%`),
    date: (iso: string) => {
        const [y, m, d] = iso.split('-');
        return `${d}/${m}/${y}`;
    },
    shortDate: (iso: string) => {
        const [, m, d] = iso.split('-');
        return `${d}/${m}`;
    },
    day: (n: number | null | undefined) => (n == null ? '—' : `D${n}`),
};

export const BASIS_LABEL: Record<CacBasis, string> = {
    lead: 'lead que iniciou',
    conversation: 'conversa Meta',
};

/** Campo de LTV/CAC conforme a base escolhida. */
export const ltvKey = (basis: CacBasis): 'ltv_lead' | 'ltv_conversation' => (basis === 'lead' ? 'ltv_lead' : 'ltv_conversation');
export const cacKey = (basis: CacBasis): 'cac_lead' | 'cac_conversation' => (basis === 'lead' ? 'cac_lead' : 'cac_conversation');

export const OBJECTIVE_LABEL: Record<string, string> = {
    OUTCOME_SALES: 'Vendas',
    OUTCOME_ENGAGEMENT: 'Engajamento',
    OUTCOME_LEADS: 'Leads',
    OUTCOME_TRAFFIC: 'Tráfego',
    OUTCOME_AWARENESS: 'Reconhecimento',
    '': '(sem objetivo)',
};

export const objectiveLabel = (value: string) => OBJECTIVE_LABEL[value] ?? value;

export const CHANNEL_LABEL: Record<string, string> = {
    messenger: 'Messageria',
    push: 'Push',
    sms: 'SMS',
    other: 'Outros trackings',
    untracked: 'Sem tracking',
};

export const CHANNEL_COLOR: Record<string, string> = {
    messenger: '#10b981',
    push: '#3b82f6',
    sms: '#8b5cf6',
    other: '#f59e0b',
    untracked: '#64748b',
};
